import script from "./PaymentPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentPage.vue?vue&type=script&setup=true&lang=js"

import "./PaymentPage.vue?vue&type=style&index=0&id=0aa242d2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0aa242d2"]])

export default __exports__